import script from "./AboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=1b6fc79e&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6fc79e"]])

export default __exports__